var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70502 11.5007L0.589672 4.38537C-0.196501 3.59919 -0.196501 2.32461 0.589672 1.53967L1.53824 0.591103C2.32466 -0.195315 3.59924 -0.195315 4.38418 0.591103L11.4993 7.70621L18.6146 0.589629C19.4008 -0.196543 20.6754 -0.196543 21.4603 0.589629L22.4104 1.53819C23.1965 2.32461 23.1965 3.59919 22.4104 4.38414L15.2938 11.5007L22.4089 18.6158C23.1953 19.4022 23.1953 20.6768 22.4089 21.4618L21.4603 22.4103C20.6742 23.1965 19.3996 23.1965 18.6146 22.4103L11.4993 15.295L4.38418 22.4103C3.59776 23.1965 2.32318 23.1965 1.53824 22.4103L0.589672 21.4618C-0.196501 20.6753 -0.196501 19.4008 0.589672 18.6158L7.70502 11.5007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "matrix(-1 0 0 1 23 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.c3b9628168eac1ec0608b5fbf38a6d7a.svg";
export { ForwardRef as ReactComponent };